Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector);



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/Element.prototype.matches.js
// module id = 591
// module chunks = 11